module.exports = __webpack_public_path__ + "img/apa-itu-sistem-pengawasan.4bf44c2b.png";